module.exports = __webpack_public_path__ + "img/chat.71dd6728.png";